import { z } from "zod";
import { oc } from "@orpc/contract";
//#region src/api/orpc/internal/kotoneCredit.ts
const exchangeCreditPackInputSchema = z.object({ skuId: z.string() });
const exchangeCreditPackOutputSchema = z.object({
	orderId: z.coerce.bigint(),
	creditPackId: z.string(),
	creditAmount: z.number().int(),
	pixaiPaidCreditsCount: z.number().int().positive()
});
const claimMonthlyMembershipCreditPackOutputSchema = z.object({
	orderId: z.coerce.bigint(),
	creditPackId: z.string(),
	creditAmount: z.number().int().positive(),
	nextClaimableAt: z.iso.datetime()
});
const monthlyMembershipGrantStatusOutputSchema = z.object({
	claimable: z.boolean(),
	creditAmount: z.number().int().positive().nullable(),
	pixaiMembershipTier: z.number().int().nullable(),
	nextClaimableAt: z.iso.datetime().nullable(),
	lastClaimedAt: z.iso.datetime().nullable()
});
const kotoneCreditContract = oc.prefix("/kotone/credit").tag("Kotone").router({
	exchangeCreditPack: oc.route({
		method: "POST",
		path: "/exchange-credit-pack",
		summary: "Exchange pixai credits for a kotone credit pack"
	}).input(exchangeCreditPackInputSchema).output(exchangeCreditPackOutputSchema).errors({
		SKU_NOT_FOUND: {
			status: 404,
			message: "Credit pack SKU not found or not available for exchange"
		},
		INSUFFICIENT_BALANCE: {
			status: 400,
			message: "Insufficient pixai credits"
		}
	}),
	claimMonthlyMembershipCreditPack: oc.route({
		method: "POST",
		path: "/claim-monthly-membership-credit-pack",
		summary: "Claim monthly membership kotone credit pack"
	}).output(claimMonthlyMembershipCreditPackOutputSchema).errors({
		NO_ACTIVE_SUBSCRIPTION: {
			status: 403,
			message: "No active membership subscription"
		},
		COOLDOWN_ACTIVE: {
			status: 429,
			message: "Cooldown period active, try again later"
		},
		TIER_NOT_ELIGIBLE: {
			status: 403,
			message: "Current membership tier is not eligible for credit grant"
		}
	}),
	getMonthlyMembershipGrantStatus: oc.route({
		method: "GET",
		path: "/monthly-membership-grant-status",
		summary: "Get monthly membership credit pack grant status"
	}).output(monthlyMembershipGrantStatusOutputSchema)
});
//#endregion
export { claimMonthlyMembershipCreditPackOutputSchema, exchangeCreditPackInputSchema, kotoneCreditContract };
